import { create } from 'zustand';

type ThemeMode = 'light' | 'dark' | 'ediphor';

interface ThemeStore {
  mode: ThemeMode;
  toggleTheme: () => void;
  setTheme: (mode: ThemeMode) => void;
}

const THEME_KEY = 'ediphor_theme_preference';

function getInitialMode(): ThemeMode {
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === 'light' || stored === 'dark' || stored === 'ediphor') return stored;
  return 'ediphor'; // default to new Ediphor theme
}

export const useThemeStore = create<ThemeStore>((set) => ({
  mode: getInitialMode(),
  toggleTheme: () => set((state) => {
    // Cycle through: ediphor -> light -> dark -> ediphor
    const next = state.mode === 'ediphor' ? 'light' : state.mode === 'light' ? 'dark' : 'ediphor';
    localStorage.setItem(THEME_KEY, next);
    return { mode: next };
  }),
  setTheme: (mode) => {
    localStorage.setItem(THEME_KEY, mode);
    set({ mode });
  },
}));
